var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagingBtn1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 11,
    viewBox: "0 0 5 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.5L0.500001 10.2631L0.5 0.736861L5 5.5Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagingBtn1);
export default __webpack_public_path__ + "static/media/pagingBtn1.c36caac589fe7556c6c4a8bd67382c60.svg";
export { ForwardRef as ReactComponent };